

<template>
  <input  :type="type ? type : 'text'" ref="field" class="form-control input-text" v-model="innerValue"
          @focus="focus" @paste="paste"/><!-- v-on="$listeners" -->
</template>

<script>
/* eslint-disable */
import Inputmask from 'inputmask'


export default {
  name: 'LkMaskedField',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    mask: String,
    value: [String, Number],
    type: String
  },
  mounted () {
    var im = new Inputmask(this.mask)
    im.mask(this.$refs.field)
  },
  computed: {
    innerValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('change', value)
      }
    }
  },
  methods: {
    focus () {
      if (this.$listeners.focus) {
        this.$listeners.focus()
      }
    },
    paste () {
      // для борьбы с ситацияей, когда при вставке текста v-model не срабатывает
      this.innerValue = this.$refs.field.value
      setTimeout(() => { this.innerValue = this.$refs.field.value }, 100)
    }
  }
}
</script>
